var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-key_svg__clip0_100_5011)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.999 26.04V40L19.398 24.224a5.412 5.412 0 00-4.711-.993 11.81 11.81 0 01-10.605-2.504c-4.71-4.058-5.448-11.117-1.679-16.07A11.705 11.705 0 0110.287.098a11.688 11.688 0 018.774 2.422 11.794 11.794 0 013.796 13.32l-.952-.731c1.376-4.19.02-8.89-3.548-11.692a10.571 10.571 0 00-7.925-2.187 10.573 10.573 0 00-7.12 4.116 10.61 10.61 0 00-2.1 7.558c.283 2.721 1.566 5.193 3.614 6.956a10.674 10.674 0 009.581 2.263 6.546 6.546 0 015.691 1.196l18.76 14.37v-3.473L20.251 19.925l.348-.452 18.26 14.023v-6.314h-4.642v-3.878h-3.685l-5.549-4.29.695-.906 5.243 4.055h4.437v3.878h4.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.67 4.612c-4.01 0-7.275 3.266-7.275 7.278s3.264 7.28 7.275 7.28c4.012 0 7.274-3.267 7.274-7.28 0-4.014-3.262-7.278-7.274-7.278zm0 13.987c-3.697 0-6.705-3.01-6.705-6.71 0-3.699 3.008-6.707 6.705-6.707 3.698 0 6.704 3.01 6.704 6.708 0 3.698-3.007 6.709-6.704 6.709z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-key_svg__clip0_100_5011"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default SvgIconKey;